<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">
        <app-i18n code="home.menu"></app-i18n>
      </el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/training' }">
        <app-i18n code="entities.training.menu"></app-i18n>
      </el-breadcrumb-item>
      <el-breadcrumb-item>
        <app-i18n code="entities.training.view.title"></app-i18n>
      </el-breadcrumb-item>
    </el-breadcrumb>

    <div class="app-content-page">
      <h1 class="app-content-title app-content-title--hidden">
        <app-i18n code="entities.training.view.title"></app-i18n>
      </h1>

      <div class="app-page-spinner" v-if="loading" v-loading="loading"></div>

      <app-training-view-toolbar v-if="record"></app-training-view-toolbar>

      <el-form
        :label-position="labelPosition"
        :label-width="labelWidthForm"
        @submit.prevent.native
        class="form"
        v-if="record"
      >
        <app-view-item-text :label="fields.id.label" :value="presenter(record, 'id')"></app-view-item-text>

        <app-view-item-text :label="fields.title.label" :value="presenter(record, 'title')"></app-view-item-text>

        <app-view-item-text :label="fields.description.label" :value="presenter(record, 'description')"></app-view-item-text>

        <app-view-item-text :label="fields.date.label" :value="presenter(record, 'date')"></app-view-item-text>

        <app-view-item-text :label="fields.hour.label" :value="presenter(record, 'hour')"></app-view-item-text>

        <app-view-item-text :label="fields.duration.label" :value="presenter(record, 'duration')"></app-view-item-text>

        <app-view-item-text :label="fields.location.label" :value="presenter(record, 'location')"></app-view-item-text>

        <app-view-item-text :label="fields.status.label" :value="presenter(record, 'status')"></app-view-item-text>

        <app-view-item-relation-to-one
          :label="fields.team.label"
          :permission="fields.team.readPermission"
          :url="fields.team.viewUrl"
          :value="presenter(record, 'team')"
        ></app-view-item-relation-to-one>

        <app-view-item-text :label="fields.createdAt.label" :value="presenter(record, 'createdAt')"></app-view-item-text>

        <app-view-item-text :label="fields.updatedAt.label" :value="presenter(record, 'updatedAt')"></app-view-item-text>
      </el-form>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import TrainingViewToolbar from '@modules/training/components/training-view-toolbar.vue';
import { TrainingModel } from '@modules/training/training-model';

const { fields } = TrainingModel;

export default {
  name: 'app-training-view-page',

  props: ['id'],

  components: {
    [TrainingViewToolbar.name]: TrainingViewToolbar,
  },

  computed: {
    ...mapGetters({
      labelPosition: 'layout/labelPosition',
      labelWidthForm: 'layout/labelWidthForm',
      record: 'training/view/record',
      loading: 'training/view/loading',
    }),

    fields() {
      return fields;
    },
  },

  async created() {
    await this.doFind(this.id);
  },

  methods: {
    ...mapActions({
      doFind: 'training/view/doFind',
    }),

    presenter(record, fieldName) {
      return TrainingModel.presenter(record, fieldName);
    },
  },
};
</script>
